export const TO_LOGIN = '/login';
export const TO_REGISTER = '/register';
export const TO_FORGOT_PASSWORD = '/forgot-password';
export const TO_PROFILE = '/profile';
export const TO_RESET_PASSWORD = '/reset-password';
export const TO_INGREDIENTS = '/ingredients';
export const TO_ORDERS = '/orders';
export const TO_FEED = '/feed';
